import moment from 'moment'

moment.updateLocale('en', {
  relativeTime: {
    future: function (input) {
      if (!input.includes('seconds')) return `in ${input}`
      return parseInt(input) < 10 ? 'just now' : 'in a few seconds'
    },
    past: function (input) {
      if (!input.includes('seconds')) return `${input} ago`
      return parseInt(input) < 10 ? 'just now' : 'a few seconds ago'
    },
    s: '%d seconds'
  }
})

export default moment



// WEBPACK FOOTER //
// ./src/utils/moment.js